export type ChangeLanguageEvent = (newLanguage: string) => void;

export type ChangeLanguageUnsubscribe = () => void;

export type ChangeLanguageSubscribe = (subscription: ChangeLanguageEvent) => ChangeLanguageUnsubscribe;

const DEFAULT_LANGUAGE = 'en';

let currentLanguage = DEFAULT_LANGUAGE;

const subscriptions: ChangeLanguageEvent[] = [];

export function subscribe(subscription: ChangeLanguageEvent): ChangeLanguageUnsubscribe {
  subscriptions.push(subscription);
  return () => {
    subscriptions.filter((sub) => sub !== subscription);
  };
}

export function set(value: string): void {
  currentLanguage = value;
  subscriptions.forEach((sub) => sub(currentLanguage));
}

export function get() {
  return currentLanguage;
}
